"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRAINING_IMAGE_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var BoundingBoxesFragment_1 = require("./BoundingBoxesFragment");
var SimpleProductFragment_1 = require("./SimpleProductFragment");
exports.TRAINING_IMAGE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment TrainingImage on TrainingImage {\n    id\n    url\n    bucketFileName\n  }\n  ", "\n  ", "\n"], ["\n  fragment TrainingImage on TrainingImage {\n    id\n    url\n    bucketFileName\n  }\n  ", "\n  ", "\n"])), BoundingBoxesFragment_1.BOUNDING_BOXES_FRAGMENT, SimpleProductFragment_1.SIMPLE_PRODUCT_FRAGMENT);
var templateObject_1;
